const handleControls = (swiper, controls) => {
  if (!controls) return

  try {
    if (swiper.isBeginning && swiper.isEnd) {
      controls.classList.add('force-hidden')
    } else {
      controls.classList.remove('force-hidden')
    }
  } catch (e) {
    // defensive: if swiper isn't fully initialised yet
    // keep controls visible so user can still navigate
    controls.classList.remove('force-hidden')
  }
}

const init = async () => {
  // Ensure CSS is loaded before initialising
  await import('swiper/css')

  const { default: Swiper, Navigation, Pagination } = await import('swiper')

  Swiper.use([Navigation, Pagination])

  document.querySelectorAll('.element-newsevents').forEach((el, idx) => {
    const container = el.querySelector('.swiper')
    if (!container) {
      // nothing to do
      // console.debug for easier local debugging
      console.debug(`NewsEvents: missing .swiper container for element index ${idx}`)
      return
    }

    const slides = el.querySelectorAll('.swiper-slide')
    const numSlides = slides.length
    const controls = el.querySelector('.slider-controls')
    const nextBtn = el.querySelector('.slider-control-next')
    const prevBtn = el.querySelector('.slider-control-prev')

    if (numSlides <= 1) return

    // Defensive: pass DOM elements directly to navigation so Swiper can attach
    const navigation = {
      nextEl: nextBtn || undefined,
      prevEl: prevBtn || undefined,
    }

    const paginationEl = el.querySelector('.slider-pagination')

    try {
      const swiper = new Swiper(container, {
        slidesPerView: 'auto',
        preloadImages: false,
        simulateTouch: false,
        loop: true,
        loopedSlides: numSlides,
        pagination: paginationEl
          ? {
              el: paginationEl,
              type: 'custom',
              renderCustom: (_, current, total) => `${current} of ${total}`,
            }
          : undefined,
        navigation,
        breakpoints: {
          768: {
            slidesPerGroup: 2,
          },
          1024: {
            slidesPerGroup: 3,
          },
        },
        on: {
          resize: (s) => handleControls(s, controls),
          afterInit: (s) => handleControls(s, controls),
        },
      })

      // If Swiper didn't attach navigation (older versions or DOM issues), add fallback handlers
      setTimeout(() => {
        const navAttached = swiper.navigation && swiper.navigation.init && swiper.navigation.init
        if ((!navAttached || !swiper.navigation.nextEl || !swiper.navigation.prevEl) && (nextBtn || prevBtn)) {
          console.debug('NewsEvents: attaching fallback click handlers for navigation')
          if (nextBtn) nextBtn.addEventListener('click', () => swiper.slideNext())
          if (prevBtn) prevBtn.addEventListener('click', () => swiper.slidePrev())
        }
      }, 50)
    } catch (err) {
      console.error('NewsEvents: failed to initialise Swiper', err)

      // Fallback: attach simple click handlers to show some navigation behavior
      if (nextBtn || prevBtn) {
        const fakeSwiper = {
          index: 0,
          slideNext() {
            this.index = Math.min(this.index + 1, numSlides - 1)
            // try to scroll the container to the next slide
            const next = slides[this.index]
            if (next) next.scrollIntoView({ behavior: 'smooth', inline: 'center' })
          },
          slidePrev() {
            this.index = Math.max(this.index - 1, 0)
            const prev = slides[this.index]
            if (prev) prev.scrollIntoView({ behavior: 'smooth', inline: 'center' })
          },
        }

        if (nextBtn) nextBtn.addEventListener('click', () => fakeSwiper.slideNext())
        if (prevBtn) prevBtn.addEventListener('click', () => fakeSwiper.slidePrev())
      }
    }
  })
}

init()
